import memoize from 'lodash/memoize';

import sanitizeTopic from 'sanitizers/sanitizeTopic';

import { TopicLink } from 'types';

export default memoize((topics: unknown[]): TopicLink[] => {
  return topics.map(sanitizeTopic);
});
